import React from 'react';
import type { AssistantArtifact } from 'components/framework/models';
import SharePopover from './SharePopover';
import { ApplicationView } from '@aha-app/mvc';

interface ShareArtifactPopoverProps {
  artifact: AssistantArtifact;
  version?: number;
}

const ShareArtifactPopover: React.FC<ShareArtifactPopoverProps> = ({
  artifact,
  version,
}) => {
  const shareUrl = `/assistant/shared_artifacts/${artifact.token}/${
    version || 1
  }`;

  return (
    <SharePopover
      shareUrl={shareUrl}
      name='artifact'
      tokenOwner={artifact}
      iconOnly
      buttonKind='icon'
    />
  );
};

export default ApplicationView(ShareArtifactPopover);
